import { useState } from "react";
import plur from "plur";
import { toast } from "@jsq/ds/core";
import { useEndArenaAccessMutation } from "~/graphql/supergraphHooks";
import { toGlobalId } from "~/utils/graphql-helpers";

type endArenaAccessParams = {
  arenaIds: number[];
  userIds: string[];
};

export const useRemoveUserModal = () => {
  const [removeUser, { loading }] = useEndArenaAccessMutation();
  const [isOpen, setIsOpen] = useState(true);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const endArenaAccess = async ({ arenaIds, userIds }: endArenaAccessParams) => {
    const globalArenaIds = arenaIds.map((id) => toGlobalId("ArenaObjectType", id));
    const globalUserIds = userIds.map((id) => toGlobalId("UserObjectType", id));

    const errorMsg = `Failed to remove ${plur("user", userIds.length)} from ${plur("workspace", arenaIds.length)}`;
    const successMsg = `${plur("User", userIds.length)} removed from ${plur("workspace", arenaIds.length)}`;

    try {
      const response = await removeUser({
        fetchPolicy: "network-only",
        variables: {
          input: {
            arenaIds: globalArenaIds,
            userIds: globalUserIds,
          },
        },
        refetchQueries: ["ArenaAccessForArena", "GetWorkspaces"],
      });
      const data = response.data?.endArenaAccess;

      if (data?.__typename === "EndArenaAccessResponse") {
        toast.success(successMsg);
        closeModal();
      } else if (data?.__typename === "MutationErrorResponse") {
        toast.error(data.message);
      } else {
        toast.error(errorMsg);
      }
    } catch {
      toast.error(errorMsg);
    }
  };

  return {
    isOpen,
    openModal,
    closeModal,
    endArenaAccess,
    loading,
  };
};
